module.exports = __webpack_public_path__ + "static/media/alert_partner_white_x2_new.3a2b1ab6.png";